import { combineReducers } from 'redux'
import AuthReducer from './AuthReducer'
import PublicationReducer from './PublicationReducer'
import SearchArtistsReducer from './SearchArtistsReducer'
import SearchMembersReducer from './SearchMembersReducer'
import FollowReducer from './FollowReducer'
import CommunityReducer from './CommunityReducer'
import LoadingReducer from './LoadingReducer'
import CoverReducer from './CoverReducer'
import PodcastsReducer from './PodcastsReducer'

// COMBINED REDUCERS
const reducers = {
    cover: CoverReducer,
    publication: PublicationReducer,
    auth: AuthReducer,
    podcasts: PodcastsReducer,
    searchArtists: SearchArtistsReducer,
    searchMembers: SearchMembersReducer,
    follow: FollowReducer,
    community: CommunityReducer,
    loading: LoadingReducer
}

export default combineReducers(reducers)